import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import errorSlice from "../../Services/errorSlice";
import { alertSnackbarError, alertSnackbarSuccess } from "./alertStatusSlice";
import settingService from "../../Services/setting.service";

const initialState = {
  loading: false,
  result: [],

  detail_load: false,
  detail_logo: "",
  detail_name: "",
  status_register: "N",
};
export const settingList = createAsyncThunk(
  "setting/list",
  async (values, thunkAPI) => {
    try {
      const result = await settingService.list(values).then((respone) => {
        const { data } = respone;
        return data.result;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const webDetail = createAsyncThunk(
  "setting/webDetail",
  async (thunkAPI) => {
    try {
      const result = await settingService.web_detail().then((respone) => {
        const { data } = respone;
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const settingUpdate = createAsyncThunk(
  "setting/update",
  async (values, thunkAPI) => {
    try {
      const result = await settingService.update(values).then((respone) => {
        const { data } = respone;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const settingSlice = createSlice({
  name: "settingSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(settingList.pending, (state, action) => {
      state.loading = true;
      state.result = [];
    });
    builder.addCase(settingList.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(settingList.rejected, (state, action) => {
      state.loading = false;
      state.result = [];
    });

    builder.addCase(webDetail.pending, (state, action) => {
      state.detail_load = true;
      state.detail_logo = "";
      state.detail_name = "";
      state.status_register = "N";
    });
    builder.addCase(webDetail.fulfilled, (state, action) => {
      state.detail_load = false;
      state.detail_logo = action.payload.logo;
      state.detail_name = action.payload.name;
      state.status_register = action.payload.status_register;
    });
    builder.addCase(webDetail.rejected, (state, action) => {
      state.detail_load = false;
      state.detail_logo = "";
      state.detail_name = "";
      state.status_register = "N";
    });
  },
});

export const { reducer } = settingSlice.actions;

export default settingSlice.reducer;
